export const GaUtil = {
  NOTICE_POPUP_IMAGE_CLICK: () => {
    try {
      window.gtag('event', 'click', {
        content_id: 'notice_popup_image',
      });
    } catch (error) {
      console.log('Error : click_notice_popup_image');
    }
  },
};
